<script setup>
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue'
import { Inertia } from '@inertiajs/inertia'
import JetInput from '@/Jetstream/Input.vue'
import JetTextarea from '@/Jetstream/Textarea.vue'
import JetLabel from '@/Jetstream/Label.vue'
import { computed } from 'vue'

const honeypot = computed(() => usePage().props.value.honeypot)

const form = useForm({
    first_name: '',
    last_name: '',
    email: '',
    company: '',
    message: '',
    property_id: null,
    [honeypot.nameFieldName]: '',
    [honeypot.validFromFieldName]: honeypot.encryptedValidFrom,
    reference: 'Contact Us Page'
});

const submit = () => {
    form.post(route('contact.store'), {
        onSuccess: () => form.reset('first_name', 'last_name', 'email', 'company', 'message'),
    });
}
</script>

<script>
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default {
    mounted(){
        document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/development-consultancy-banner.jpg') + '")';
        document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
        document.querySelector('section.page-header').style.backgroundSize = 'cover';
        document.querySelector('section.page-header').style.backgroundPosition = 'center';

        let client_slide_1 = new Splide(".clients-splide-1", {
            gap: `2em`,
            padding: "5em",
            pagination: false,
            arrows: false,
            perPage: 5,
            perMove:1,

            //   focus: "center",
            type: "loop",
            autoScroll: {
                speed: 1,
            },
            breakpoints: {
                1200:{
                    padding: "0em",
                },
                992: {
                    perPage: 4,
                },
                768: {
                    perPage: 3,
                },
                576:{
                    perPage:2,
                },
                425:{
                    perPage:2,
                },
            },
        });

        client_slide_1.mount( {AutoScroll} );

    }
}
</script>

<template>
    <AppLayout title="Consultation On Every Stage Of The Property Development Process" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">DEVELOPMENT CONSULTANCY</a></li>
                </ol>
            </nav>
            <div>
                <h2 class="page-header-heading">Intelligent Development Strategies</h2>
            </div>
        </template>

        <section class="about-us bg-bulk">
            <div class="about-us-top pt-2 pt-lg-auto">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 ps-lg-5 px-auto">
                            <div class="headings d-lg-none pb-4">
                                <h2>
                                    How It Works?
                                </h2>
                            </div>
                            <div class="img-container">
                                <figure>
                                    <img :src="asset('/images/development-consultancy/development-consultancy-description.jpg')">
                                </figure>
                            </div>
                        </div>
                        <div class="col-lg-6 pe-lg-5 px-auto">
                            <div class="headings">
                                <h2 class="d-none d-lg-block">
                                    How It Works?
                                </h2>
                                <p>
                                    Real Estate is the backdrop necessary for life to emerge and sustain itself. The places we live in, work at, shop from become important character of our stories. Naturally, the process of developing this takes an army of people working tirelessly towards the same goal.
                                </p>
                                <p>
                                    We aim to make this journey easy for everyone from novice aspirants to veteran developers.
                                </p>
                                <p></p>
                                <button class="btn custom-black-button" data-bs-toggle="modal" data-bs-target="#enquiryModal">Get Inspired</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="timeline" id="end">
            <div class="container mb-5">
                <div class="row align-items-center">
                    <div class="col-lg-8 headings">
                        <h2>With You at Every Stage</h2>
                        <p>With our end-to-end service module, we consult developers on every stage of the
                            development process right from Planning to Delivery.</p>
                    </div>
                </div>
            </div>
            <div class="container position-relative">
                <div class="line"></div>
                <div class="row">
                    <div class="col-12 offset-lg-0 col-lg-6 position-relative">
                        <div class="card ms-5 ms-lg-0 me-lg-5">
                            <img class="card-img-top" :src="asset('/images/development-consultancy-planning.png')" alt="Planning">
                            <div class="card-body p-4">
                                <h4 class="card-title">Planning</h4>
                                <p class="card-text">At the beginning of any project, our consultants sit with developers and outline financial and branding goals.</p>
                            </div>
                        </div>
                        <div class="dashed"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="col-12 offset-lg-6 col-lg-6 pt-5 position-relative mt-n5">
                        <div class="card ms-5 ms-lg-0 ms-lg-5">
                            <img class="card-img-top" :src="asset('/images/development-consultancy-land.png')" alt="Land">
                            <div class="card-body p-4">
                                <h4 class="card-title">Land Selection</h4>
                                <p class="card-text">Based on their inputs, we create a list of lands available in the market.</p>
                                <p class="card-text">A detailed feasibility study with Estimated Project Cost, Cash Flow Requirements and Sales Forecast is designed for all the shortlisted pieces of land.</p>
                            </div>
                        </div>
                        <div class="dashed right"></div>
                        <div class="dot right"></div>
                    </div>
                    <div class="col-12 offset-lg-0 col-lg-6 pt-5 position-relative mt-n5">
                        <div class="card ms-5 ms-lg-0 me-lg-5">
                            <img class="card-img-top" :src="asset('/images/development-consultancy-design-and-approval.png')" alt="Design And Approval">
                            <div class="card-body p-4">
                                <h4 class="card-title">Design & Approval</h4>
                                <p class="card-text">Once the land is finalized, we work with our partner Architects & Design Consultants to create the most efficient design for the project keeping in mind the Developer's predetermined goals.</p>
                            </div>
                        </div>
                        <div class="dashed"></div>
                        <div class="dot"></div>
                    </div>
                    <div class="col-12 offset-lg-6 col-lg-6 pt-5 position-relative mt-n5">
                        <div class="card ms-5 ms-lg-0 ms-lg-5">
                            <img class="card-img-top" :src="asset('/images/development-consultancy-construction.png')" alt="Construction">
                            <div class="card-body p-4">
                                <h4 class="card-title">Construction</h4>
                                <p class="card-text">After the design is approved, we help the Developer float a tender among our experienced Contracting partners and help them finalize the best option.</p>
                            </div>
                        </div>
                        <div class="dashed right"></div>
                        <div class="dot right"></div>
                    </div>
                    <div class="col-12 offset-lg-0 col-lg-6 pt-5 position-relative mt-n5">
                        <div class="card ms-5 ms-lg-0 me-lg-5">
                            <img class="card-img-top" :src="asset('/images/development-consultancy-sales-strategy.png')" alt="Sales Strategy">
                            <div class="card-body p-4">
                                <h4 class="card-title">Sales Strategy</h4>
                                <p class="card-text">At this stage, we design a Sales Strategy needed for realizing the Cash Flow targets set at the beginning.</p>
                                <p class="card-text">We also partner with qualified lawyers to ensure easy Transfer of Titles with no outstanding liability on the Developer.</p>
                            </div>
                        </div>
                        <div class="dashed"></div>
                        <div class="dot"></div>
                    </div>
                </div>
            </div>
        </section>
        <section class="our-values" id="value-addition">
            <div class="container-fluid px-lg-0 py-5">
                <div class="row align-items-center px-lg-0 mx-lg-0">
                    <div class="col-lg-6 px-0">
                        <div class="assets-img">
                            <figure class="mb-0">
                                <img :src="asset('/images/development-consultancy-usp.jpg')" alt="Our Achievements">
                            </figure>
                        </div>
                    </div>
                    <div class="col-lg-6 mt-5 mt-lg-0  ps-5">
                        <div class="current-assets-content">
                            <div class="headings">
                                <h2>Value Addition</h2>
                                <div class="accordion mt-4" id="accordionPanelsStayOpenExample">
                                    <div class="accordion-item">
                                        <button class="text-uppercase accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                                           <span>01.</span> 17 Years of Market Experience
                                        </button>
                                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                            <div class="accordion-body">
                                                <p>
                                                    As a team, we have worked in every domain of Dubai Real Estate from Development to Brokerage & Contracting. Having seen the market go through all kinds of cyclic variations, we have a very good projection of the future. Integrating this experience into a developer's business strategy is a sure shot recipe for value-based growth and long-term sustainability.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <button class="text-uppercase accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                                             <span>02.</span> Specialized Partners
                                        </button>
                                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                            <div class="accordion-body">
                                                <p>
                                                    Over the years, we have had the opportunity to work with the finest minds in Dubai Real Estate. With every job well done, we rate the experience based on our tailor-made qualification criteria for future referrals. Today, we have an extensive list of vendors for every stage of the development process from design consultants to contractors and marketing professionals.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <button class="text-uppercase accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                            <span>03.</span> Well Established Process
                                        </button>
                                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                            <div class="accordion-body">
                                                <p>
                                                    Growth & sustenance of any business is not dependent on how good its most successful project was but on how successful its average projects are. To ensure repeated on-time delivery of projects and assured value appreciation for investors, developers must establish a detailed process. This must be grounded in long term experience and updated with real-time market variations. We have successfully laid out a well-stablished process so first-time developers can also be as efficient as a veteran.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <button class="text-uppercase accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                                            <span>04.</span> Specialized Troubleshooting
                                        </button>
                                        <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                                            <div class="accordion-body">
                                                <p>
                                                    On the road to creating memorable real estate projects, one is always hit with unexpected curves. With extensive experience, we have developed sophisticated techniques to zero in on the problem and find the most elegant solutions. Consider us as the antivirus of the Development process.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="associates" id="associate">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 headings">
                        <h2>Our Associates</h2>
                        <p>We constantly stretch our thinking to seek out innovative, sustainable solutions for the world's toughest challenges</p>
                    </div>
                </div>
            </div>
            <div class="container-fluid p-0 mt-4 mb-5">
                <div class="row w-100 m-0">
                    <div class="splide clients-splide-1" role="group" aria-label="Splide
                        Basic HTML Example">
                        <div class="splide__track">
                            <ul class="splide__list">
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/damac.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/ellington.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/emaar.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/mag.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/nakheel.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/nshama.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/omniyat.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/select-group.svg"
                                        alt="">
                                    </figure>
                                </li>
                                <li class="splide__slide">
                                    <figure>
                                        <img src="/images/development-consultancy/our-associates/sobha.svg"
                                        alt="">
                                    </figure>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </AppLayout>
</template>

<style scoped>

</style>
